import React, { useState, useEffect } from "react";
import CustomButtonComponent from "../../../../core/custom-button";
import CustomTable from "../../../../core/custom-table";
import { HeaderConfig } from "./config";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import CreateWsm from "./create-wsm";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { IconButton } from "@mui/material";
import WSMFilters from "./wsm-filters";
import { PAGE_LIMIT } from "../../../../utils";
import DeleteModal from "../../../../components/delete-modal";
import AttachmentModal from "../../../../components/attachment-modal";

const WorkshopManualAdmin = () => {
  const [wsmData, setWsmData] = useState({
    results: [],
  });
  const [editData, setEditData] = useState({});
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });
  const [mainFilters, setMainFilters] = useState({});
  const [downloadAttachment, setDownloadAttachment] = useState({
    isOpen: false,
    data: [],
  });
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
    approvalStatus: "APPROVED",
  });
  const [isCreate, setIsCreate] = useState(false);
  const loadData = (filter) => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}`,
      null,
      filter
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results
            ?.map((ele, index) => {
              return {
                ...ele,
                sNo: index + 1,
              };
            })
            .filter((ele) => ele && ele);

          setWsmData({ ...res, results: result });
        }
      })
      .catch((err) => console.error(err));
  };
  const deleteHandler = () => {
    const id = isDelete?.data?.id;

    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}/${id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
        }
        setIsDelete({ isOpen: false, data: {} });
        loadData(filters);
      })
      .catch((err) => console.error(err));
  };

  const ClickHandler = (type, data) => {
    switch (type) {
      case "DOWNLOAD":
        setDownloadAttachment({
          isOpen: true,
          data: [data.document],
        });
        break;
      case "EDIT":
        setIsCreate(true);
        setEditData(data);
        break;
      case "DELETE":
        setIsDelete({ isOpen: true, data: data });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  useEffect(() => {
    if (wsmData?.totalPages !== 0 && wsmData?.totalPages < wsmData?.page) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [wsmData]);
  return (
    <>
      <div className="page-body">
        <div className=" view-detailed-ticket">
          {isCreate && (
            <IconButton
              onClick={() => {
                setIsCreate(false);
                setEditData({});
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <div>
            <p className="tab-name">Literature</p>
            <p className="section-name">Workshop Manual</p>
          </div>
        </div>
        {isCreate ? (
          <CreateWsm
            loadData={loadData}
            wsmData={wsmData}
            setIsCreate={setIsCreate}
            editData={editData}
          />
        ) : (
          <div>
            <div className="create-con">
              <p className="primary-text">Workshop Manual Index</p>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                onClick={() => setIsCreate(true)}
              >
                Create WSM
              </CustomButtonComponent>
            </div>
            <div className="si-hide-mobile">
              <CustomTable
                header={HeaderConfig(wsmData.results || [])}
                data={wsmData.results || []}
                pageCount={wsmData.totalPages}
                onClick={ClickHandler}
                filters={filters}
                onChange={(page) => {
                  setFilters({
                    ...filters,
                    page,
                  });
                  loadData({
                    ...filters,
                    ...mainFilters,
                    page,
                  });
                }}
                filterCom={
                  <WSMFilters
                    loadData={loadData}
                    setMainFilters={setMainFilters}
                    filter={filters}
                  />
                }
              />
            </div>
          </div>
        )}
        {isDelete?.isOpen && (
          <DeleteModal
            deleteHandler={deleteHandler}
            onClose={() => {
              setIsDelete({ isOpen: false, data: {} });
            }}
          />
        )}
        {downloadAttachment?.isOpen && (
          <AttachmentModal
            attachments={downloadAttachment?.data}
            onClose={() => setDownloadAttachment({ isOpen: false, data: [] })}
          />
        )}
      </div>
    </>
  );
};

export default WorkshopManualAdmin;
